import axios from "axios";
import router from "@/router";
import { Message } from "view-ui-plus";

// 超时设定
axios.defaults.timeout = 150000;
axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    Message.error("请求超时");
    return Promise.resolve(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    const data = response.data;
    // 根据返回的code值来做不同的处理(和后端约定)
    switch (data.code) {
      case 400:
        // 未登录 清除已登录状态
        sessionStorage.clear();
        Message.error("您未登录或登录超时，请重新登录");
        router.push({ path: "/login" });
        break;
      case 403:
        // 没有权限
        if (data.msg !== null) {
          Message.error(data.msg);
        } else {
          Message.error("未知错误");
        }
        break;
      default:
        return data;
    }
    return data;
  },
  (err) => {
    // 返回状态码不为200时候的错误处理
    // Message.error(err.toString());
    return Promise.resolve(err);
  }
);

let base = "";

export const uploadFile = (data) => {
  return axios.request({
    url: `${base}/api/file/upload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data,
  });
};

/********* 管理员 ********/
export const login = (param) => {
  return axios.request({
    url: `${base}/api/manage/user/login`,
    params: param,
    method: "post",
  });
};
export const logout = () => {
  return axios.request({
    url: `${base}/api/manage/user/logout`,
    method: "get",
  });
};
export const getCurrentUser = () => {
  return axios.request({
    url: `${base}/api/manage/user/current`,
    method: "get",
  });
};
export const getManageUserList = (param) => {
  return axios.request({
    url: `${base}/api/manage/user/list`,
    method: "post",
    params: param,
  });
};
export const getManageUserDetail = (id) => {
  return axios.request({
    url: `${base}/api/manage/user/` + id,
    method: "get",
  });
};
export const saveManageUser = (param) => {
  return axios.request({
    url: `${base}/api/manage/user/save`,
    method: "post",
    data: param,
  });
};
export const deleteManageUser = (param) => {
  return axios.request({
    url: `${base}/api/manage/user/delete`,
    method: "get",
    params: param,
  });
};
export const modifyPwd = (param) => {
  return axios.request({
    url: `${base}/api/manage/user/modify/pwd`,
    method: "post",
    params: param,
  });
};
export const statistic = () => {
  return axios.request({
    url: `${base}/api/analysis/statistic`,
    method: "get",
  });
};

/********* 用户管理 ********/
export const getUserList = (param) => {
  return axios.request({
    url: `${base}/api/user/list`,
    method: "post",
    params: param,
  });
};
export const getUserDetail = (id) => {
  return axios.request({
    url: `${base}/api/user/detail/` + id,
    method: "get",
  });
};

/********* 机构管理 ********/
export const getBranchTree = (param) => {
  return axios.request({
    url: `${base}/api/branch/treeBranch`,
    method: "get",
    params: param,
  });
};
export const getBranchList = (param) => {
  return axios.request({
    url: `${base}/api/branch/list`,
    method: "get",
    params: param,
  });
};
export const getBranchDetail = (param) => {
  return axios.request({
    url: `${base}/api/branch/detail`,
    method: "get",
    params: param,
  });
};
export const saveBranch = (param) => {
  return axios.request({
    url: `${base}/api/branch/save`,
    method: "post",
    data: param,
  });
};
export const deleteBranch = (param) => {
  return axios.request({
    url: `${base}/api/branch/delete`,
    method: "get",
    params: param,
  });
};

/********* 科目管理 ********/
export const getSubjectTree = (param) => {
  return axios.request({
    url: `${base}/api/subject/treeSubject`,
    method: "get",
    params: param,
  });
};
export const getSubjectDetail = (param) => {
  return axios.request({
    url: `${base}/api/subject/detail`,
    method: "get",
    params: param,
  });
};
export const saveSubject = (param) => {
  return axios.request({
    url: `${base}/api/subject/save`,
    method: "post",
    data: param,
  });
};
export const deleteSubject = (param) => {
  return axios.request({
    url: `${base}/api/subject/delete`,
    method: "get",
    params: param,
  });
};

/********* 课程管理 ********/
export const getCourseList = (param) => {
  return axios.request({
    url: `${base}/api/course/list`,
    method: "get",
    params: param,
  });
};
export const getCourseDetail = (param) => {
  return axios.request({
    url: `${base}/api/course/detail`,
    method: "get",
    params: param,
  });
};
export const saveCourse = (param) => {
  return axios.request({
    url: `${base}/api/course/save`,
    method: "post",
    data: param,
  });
};
export const deleteCourse = (param) => {
  return axios.request({
    url: `${base}/api/course/delete`,
    method: "get",
    params: param,
  });
};
export const auditCourse = (param) => {
  return axios.request({
    url: `${base}/api/course/changeStatus`,
    method: "get",
    params: param,
  });
};
export const saveCourseBranch = (param) => {
  return axios.request({
    url: `${base}/api/course/saveCourseBranch`,
    method: "get",
    params: param,
  });
};
/********* 视频管理 ********/
export const getVideoList = (param) => {
  return axios.request({
    url: `${base}/api/video/list`,
    method: "get",
    params: param,
  });
};
export const getVideoDetail = (param) => {
  return axios.request({
    url: `${base}/api/video/detail`,
    method: "get",
    params: param,
  });
};
export const saveVideo = (param) => {
  return axios.request({
    url: `${base}/api/video/save`,
    method: "post",
    data: param,
  });
};
export const deleteVideo = (param) => {
  return axios.request({
    url: `${base}/api/video/delete`,
    method: "get",
    params: param,
  });
};
export const changeVideoStatus = (param) => {
  return axios.request({
    url: `${base}/api/video/changeStatus`,
    method: "get",
    params: param,
  });
};
/********* 资料管理 ********/
export const getCourseListDatum = (param) => {
  return axios.request({
    url: `${base}/api/course/listDatum`,
    method: "get",
    params: param,
  });
};
export const saveDatum = (param) => {
  return axios.request({
    url: `${base}/api/course/saveDatum`,
    method: "post",
    data: param,
  });
};
export const getDetailDatum = (param) => {
  return axios.request({
    url: `${base}/api/course/detailDatum`,
    method: "get",
    params: param,
  });
};
export const deleteDatum = (param) => {
  return axios.request({
    url: `${base}/api/course/deleteDatum`,
    method: "get",
    params: param,
  });
};
/********* 课程视频管理 ********/
export const getCourseVideoList = (param) => {
  return axios.request({
    url: `${base}/api/courseVideo/listVideo`,
    method: "get",
    params: param,
  });
};
export const getMayCourseVideoList = (param) => {
  return axios.request({
    url: `${base}/api/courseVideo/listMayVideo`,
    method: "get",
    params: param,
  });
};
export const getCourseVideoDetail = (param) => {
  return axios.request({
    url: `${base}/api/courseVideo/detail`,
    method: "get",
    params: param,
  });
};
export const saveCourseVideo = (param) => {
  return axios.request({
    url: `${base}/api/courseVideo/save`,
    method: "post",
    data: param,
  });
};
export const deleteCourseVideo = (param) => {
  return axios.request({
    url: `${base}/api/courseVideo/delete`,
    method: "get",
    params: param,
  });
};

/********* 课程资料管理 ********/
export const getCourseDatumList = (param) => {
  return axios.request({
    url: `${base}/api/course/courseDatum`,
    method: "get",
    params: param,
  });
};
export const getMaybeDatumList = (param) => {
  return axios.request({
    url: `${base}/api/course/maybeDatumList`,
    method: "get",
    params: param,
  });
};
export const saveSelectDatum = (param) => {
  return axios.request({
    url: `${base}/api/course/saveSelectDatum`,
    method: "get",
    params: param,
  });
};
export const deleteOneDatum = (param) => {
  return axios.request({
    url: `${base}/api/course/deleteOneDatum`,
    method: "get",
    params: param,
  });
};
/********* 学员管理 ********/
export const getLearnerList = (param) => {
  return axios.request({
    url: `${base}/api/learner/list`,
    method: "get",
    params: param,
  });
};
//查询已选中考生列表
export const getChooseList = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/user/choose/list`,
    method: "get",
    params: param,
  });
};
//查询未选中考生列表
export const getUnChooseList = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/selectUser`,
    method: "get",
    params: param,
  });
};
export const getLearnerDetail = (param) => {
  return axios.request({
    url: `${base}/api/learner/detail`,
    method: "get",
    params: param,
  });
};
export const saveLearner = (param) => {
  return axios.request({
    url: `${base}/api/learner/save`,
    method: "post",
    data: param,
  });
};
export const deleteLearner = (param) => {
  return axios.request({
    url: `${base}/api/learner/delete`,
    method: "get",
    params: param,
  });
};
export const auditLearner = (param) => {
  return axios.request({
    url: `${base}/api/learner/changeStatus`,
    method: "get",
    params: param,
  });
};

/********* 岗位管理 ********/
export const getStationList = (param) => {
  return axios.request({
    url: `${base}/api/station/list`,
    method: "get",
    params: param,
  });
};
export const getStationDetail = (param) => {
  return axios.request({
    url: `${base}/api/station/detail`,
    method: "get",
    params: param,
  });
};
export const saveStation = (param) => {
  return axios.request({
    url: `${base}/api/station/save`,
    method: "post",
    data: param,
  });
};
export const deleteStation = (param) => {
  return axios.request({
    url: `${base}/api/station/delete`,
    method: "get",
    params: param,
  });
};
export const getBranchStationList = () => {
  return axios.request({
    url: `${base}/api/station/getBranchStationList`,
    method: "get",
  });
};
export const getStationCourseList = (param) => {
  return axios.request({
    url: `${base}/api/station/getStationCourseList`,
    method: "get",
    params: param,
  });
};
export const saveStationCourse = (param) => {
  return axios.request({
    url: `${base}/api/station/saveStationCourse`,
    method: "post",
    data: param,
  });
};
export const deleteStationCourse = (param) => {
  return axios.request({
    url: `${base}/api/station/deleteStationCourse`,
    method: "get",
    params: param,
  });
};

/********* 订单管理 ********/
export const getOrderList = (param) => {
  return axios.request({
    url: `${base}/api/order/list`,
    method: "get",
    params: param,
  });
};
export const getOrderDetail = (param) => {
  return axios.request({
    url: `${base}/api/order/detail`,
    method: "get",
    params: param,
  });
};

/********* 积分管理 ********/
export const getPointList = (param) => {
  return axios.request({
    url: `${base}/api/learnerPoint/list`,
    method: "get",
    params: param,
  });
};

/********* 题库管理 ********/
export const getBankList = (param) => {
  return axios.request({
    url: `${base}/api/question/bank/list`,
    method: "post",
    params: param,
  });
};
export const getBankDetail = (param) => {
  return axios.request({
    url: `${base}/api/question/bank/detail`,
    method: "get",
    params: param,
  });
};
export const saveBank = (param) => {
  return axios.request({
    url: `${base}/api/question/bank/save`,
    method: "post",
    data: param,
  });
};
export const deleteBank = (param) => {
  return axios.request({
    url: `${base}/api/question/bank/delete`,
    method: "get",
    params: param,
  });
};

/********* 题目管理 ********/
export const getQuestionList = (param) => {
  return axios.request({
    url: `${base}/api/question/list`,
    method: "post",
    params: param,
  });
};
export const getListRule = (param) => {
  return axios.request({
    url: `${base}/api/question/listRule`,
    method: "post",
    params: param,
  });
};
export const getPaperQuestionList = (param) => {
  return axios.request({
    url: `${base}/api/question/list/paperQuestion`,
    method: "get",
    params: param,
  });
};
export const getQuestionDetail = (param) => {
  return axios.request({
    url: `${base}/api/question/detail`,
    method: "get",
    params: param,
  });
};
export const getDetailRule = (param) => {
  return axios.request({
    url: `${base}/api/question/detailRule`,
    method: "get",
    params: param,
  });
};
export const saveQuestion = (param) => {
  return axios.request({
    url: `${base}/api/question/save`,
    method: "post",
    data: param,
  });
};
export const saveRule = (param) => {
  return axios.request({
    url: `${base}/api/question/saveRule`,
    method: "post",
    data: param,
  });
};
export const deleteQuestion = (param) => {
  return axios.request({
    url: `${base}/api/question/delete`,
    method: "get",
    params: param,
  });
};
export const deleteRule = (param) => {
  return axios.request({
    url: `${base}/api/question/deleteRule`,
    method: "get",
    params: param,
  });
};

/********* 选项管理 ********/
export const getOptionList = (param) => {
  return axios.request({
    url: `${base}/api/question/option/list`,
    method: "get",
    params: param,
  });
};
export const saveOption = (param) => {
  return axios.request({
    url: `${base}/api/question/option/save`,
    method: "post",
    data: param,
  });
};
export const deleteOption = (param) => {
  return axios.request({
    url: `${base}/api/question/option/delete`,
    method: "get",
    params: param,
  });
};

/********* 试卷管理 ********/
export const getPaperList = (param) => {
  return axios.request({
    url: `${base}/api/exam/paper/list`,
    method: "post",
    params: param,
  });
};
export const getPaperDetail = (param) => {
  return axios.request({
    url: `${base}/api/exam/paper/detail`,
    method: "get",
    params: param,
  });
};
export const savePaper = (param) => {
  return axios.request({
    url: `${base}/api/exam/paper/save`,
    method: "post",
    data: param,
  });
};
export const deletePaper = (param) => {
  return axios.request({
    url: `${base}/api/exam/paper/delete`,
    method: "get",
    params: param,
  });
};
export const generatePaper = (param) => {
  return axios.request({
    url: `${base}/api/exam/paper/generate`,
    method: "get",
    params: param,
  });
};
export const previewPaper = (param) => {
  return axios.request({
    url: `${base}/api/exam/paper/preview`,
    method: "get",
    params: param,
  });
};

/********* 考试管理 ********/
export const getExamList = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/list`,
    method: "post",
    params: param,
  });
};
export const getExamDetail = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/detail`,
    method: "get",
    params: param,
  });
};
export const saveExam = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/save`,
    method: "post",
    data: param,
  });
};
export const deleteExam = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/delete`,
    method: "get",
    params: param,
  });
};
export const examChooseUser = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/user/choose`,
    method: "get",
    params: param,
  });
};
//删除一个考生
export const deleteUser = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/deleteUser`,
    method: "get",
    params: param,
  });
};
export const examUserChooseList = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/user/choose/list`,
    method: "get",
    params: param,
  });
};
export const examStart = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/start`,
    method: "get",
    params: param,
  });
};
export const examScore = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/score`,
    method: "get",
    params: param,
  });
};
export const examUserList = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/user/list`,
    method: "get",
    params: param,
  });
};
export const examUserDetail = (param) => {
  return axios.request({
    url: `${base}/api/exam/exam/user/detail`,
    method: "get",
    params: param,
  });
};

/********* 直播管理 ********/
export const getLiveList = (param) => {
  return axios.request({
    url: `${base}/api/liveSeeing/list`,
    method: "get",
    params: param,
  });
};
export const getLiveDetail = (param) => {
  return axios.request({
    url: `${base}/api/liveSeeing/detail`,
    method: "get",
    params: param,
  });
};
export const saveLive = (param) => {
  return axios.request({
    url: `${base}/api/liveSeeing/save`,
    method: "post",
    data: param,
  });
};
export const deleteLive = (param) => {
  return axios.request({
    url: `${base}/api/liveSeeing/delete`,
    method: "get",
    params: param,
  });
};
export const getLiveChooseGroup = (param) => {
  return axios.request({
    url: `${base}/api/liveSeeing/ListLiveGroup`,
    method: "get",
    params: param,
  });
};
export const saveLiveChooseGroup = (param) => {
  return axios.request({
    url: `${base}/api/liveSeeing/saveLiveGroup`,
    method: "post",
    params: param,
  });
};
export const getLiveChooseLearner = (param) => {
  return axios.request({
    url: `${base}/api/liveSeeing/ListLiveLearner`,
    method: "get",
    params: param,
  });
};
export const saveLiveChooseLearner = (param) => {
  return axios.request({
    url: `${base}/api/liveSeeing/saveLiveLearner`,
    method: "post",
    params: param,
  });
};

/********* 统计管理 ********/
export const statisticLearner = (param) => {
  return axios.request({
    url: `${base}/api/learncount/list`,
    method: "get",
    params: param,
  });
};
/********* 培训管理 ********/
export const saveProject = (param) => {
  return axios.request({
    url: `${base}/api/project/save`,
    method: "post",
    data: param,
  });
};
export const getProjectList = (param) => {
  return axios.request({
    url: `${base}/api/project/list`,
    method: "get",
    params: param,
  });
};
export const getProjectDetail = (param) => {
  return axios.request({
    url: `${base}/api/project/detail`,
    method: "get",
    params: param,
  });
};
export const deleteProject = (param) => {
  return axios.request({
    url: `${base}/api/project/delete`,
    method: "get",
    params: param,
  });
};
//查询已选中考生列表
export const getUnChooseProjectLearnerList = (param) => {
  return axios.request({
    url: `${base}/api/project/listProjectLearner`,
    method: "get",
    params: param,
  });
};
//查询已选中考生列表
export const getMaybeLearner = (param) => {
  return axios.request({
    url: `${base}/api/project/maybeLearner`,
    method: "get",
    params: param,
  });
};
export const getMaybeCourse = (param) => {
  return axios.request({
    url: `${base}/api/project/maybeCourse`,
    method: "get",
    params: param,
  });
};
export const saveProjectRelation = (param) => {
  return axios.request({
    url: `${base}/api/project/saveProjectRelation`,
    method: "post",
    data: param,
  });
};
export const getDetailProjectRelation = (param) => {
  return axios.request({
    url: `${base}/api/project/detailProjectRelation`,
    method: "get",
    params: param,
  });
};
export const deleteProjectRelation = (param) => {
  return axios.request({
    url: `${base}/api/project/deleteProjectRelation`,
    method: "get",
    params: param,
  });
};
export const getMaybeExam = (param) => {
  return axios.request({
    url: `${base}/api/project/maybeExam`,
    method: "get",
    params: param,
  });
};
export const saveLearnOrder = (param) => {
  return axios.request({
    url: `${base}/api/project/saveLearnOrder`,
    method: "get",
    params: param,
  });
};
export const saveProjectLearner = (param) => {
  return axios.request({
    url: `${base}/api/project/saveProjectLearner`,
    method: "post",
    data: param,
  });
};

export const deleteProjectLearner = (param) => {
  return axios.request({
    url: `${base}/api/project/deleteProjectLearner`,
    method: "get",
    params: param,
  });
};
//金币兑换规则
export const saveUserCoin = (param) => {
  return axios.request({
    url: `${base}/api/userCoin/save`,
    method: "post",
    data: param,
  });
};
export const getUserCoinList = (param) => {
  return axios.request({
    url: `${base}/api/userCoin/list`,
    method: "get",
    params: param,
  });
};
export const getUserCoinDetail = (param) => {
  return axios.request({
    url: `${base}/api/userCoin/detail`,
    method: "get",
    params: param,
  });
};
export const getChangeStatus = (param) => {
  return axios.request({
    url: `${base}/api/userCoin/changeStatus`,
    method: "get",
    params: param,
  });
};
//资讯管理
export const saveInformation = (param) => {
  return axios.request({
    url: `${base}/api/Information/save`,
    method: "post",
    data: param,
  });
};
export const getInformationList = (param) => {
  return axios.request({
    url: `${base}/api/Information/list`,
    method: "get",
    params: param,
  });
};
export const getInformationDetail = (param) => {
  return axios.request({
    url: `${base}/api/Information/detail`,
    method: "get",
    params: param,
  });
};
export const getChangeStatusInformation = (param) => {
  return axios.request({
    url: `${base}/api/Information/changeStatus`,
    method: "get",
    params: param,
  });
};
export const deleteInformation = (param) => {
  return axios.request({
    url: `${base}/api/Information/delete`,
    method: "get",
    params: param,
  });
};
export const getListActivity = (param) => {
  return axios.request({
    url: `${base}/api/Information/listActivity`,
    method: "get",
    params: param,
  });
};
